module.exports = {
  "country": "FI",
  "artist": "Norma John",
  "song": "Blackbird",
  "year": "2017",
  "place": "NQ",
  "spotify": "5kSAi3zcsU2zanxMleWj9y"
};